// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UsersTable_UserTable__hsEpG {
  background: #FFFFFF;
  padding: 16px 24px;
  margin-top: 24px;
}
.UsersTable_UserTable__hsEpG .UsersTable_header__EvynL {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.UsersTable_UserTable__hsEpG .UsersTable_tableAllProjects__2k26F {
  height: 72vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.UsersTable_UserTable__hsEpG .UsersTable_tableAllProjects__2k26F::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.UsersTable_UserTable__hsEpG .UsersTable_tableAllProjects__2k26F::-webkit-scrollbar-thumb {
  background-color: #04867a;
  border-radius: 50px;
}
.UsersTable_UserTable__hsEpG .UsersTable_tableAllProjects__2k26F::-webkit-scrollbar-track {
  background: #e2e4e7;
}

.UsersTable_addUserForm__TLdwy {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/usersPage/components/UsersTable/UsersTable.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAEE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,UAAA;EACA,WAAA;AADJ;AAIE;EACE,yBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAJF","sourcesContent":[".UserTable {\n  background: #FFFFFF;\n  padding: 16px 24px;\n  margin-top: 24px;\n\n  .header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n  }\n\n  .tableAllProjects {\n    height: 72vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n\n  .tableAllProjects::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n  }\n\n  .tableAllProjects::-webkit-scrollbar-thumb {\n    background-color: #04867a;\n    border-radius: 50px;\n  }\n\n  .tableAllProjects::-webkit-scrollbar-track {\n    background: #e2e4e7;\n  }\n}\n\n.addUserForm {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"UserTable": `UsersTable_UserTable__hsEpG`,
	"header": `UsersTable_header__EvynL`,
	"tableAllProjects": `UsersTable_tableAllProjects__2k26F`,
	"addUserForm": `UsersTable_addUserForm__TLdwy`
};
export default ___CSS_LOADER_EXPORT___;
